export default __webpack_public_path__ + "static/media/file.b88ada66.svg";